import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import getOriginalParentIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-original-parent-id'
import getParentIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-parent-id'

import { MEDIA_LAYOUT_TYPE, MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX } from '../../../../images/constants'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isTemporaryIdReduxUtil from '../../../../redux/utils/is-temporary-id'
import isRecommendedWorkoutUtil from '../is-recommended'

export default function getImageUriWorkoutUtil (workout, layoutType) {
  if (!workout) {
    return
  }
  const image = getValueReduxUtil(workout, WORKOUT_KEY.IMAGE)
  if (!image) {
    return
  }

  // Get the parent image workout if available
  let id
  if (isRecommendedWorkoutUtil(workout)) {
    id = getIdReduxUtil(workout)
  } else {
    id = (
      getOriginalParentIdWorkoutUtil(workout) ||
      getParentIdWorkoutUtil(workout) ||
      getIdReduxUtil(workout)
    )
  }

  if (isTemporaryIdReduxUtil(id)) {
    return
  }
  const imageSuffix = (
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[layoutType] ||
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[MEDIA_LAYOUT_TYPE.ROW]
  )
  return `workouts/${id}/${image.replace('.', `-${imageSuffix}.`)}`
}
